import React from 'react';

const IntegrationsIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 12.75H14.25C15.4926 12.75 16.5 11.7426 16.5 10.5C16.5 9.25736 15.4926 8.25 14.25 8.25H13.5V6C13.5 5.17157 12.8284 4.5 12 4.5H9.75V3.75C9.75 2.50736 8.74264 1.5 7.5 1.5C6.25736 1.5 5.25 2.50736 5.25 3.75V4.5H3C2.17157 4.5 1.5 5.17157 1.5 6V9.75H3.75C4.16421 9.75 4.5 10.0858 4.5 10.5C4.5 10.9142 4.16421 11.25 3.75 11.25H1.5V15C1.5 15.8284 2.17157 16.5 3 16.5H6.75V14.25C6.75 13.8358 7.08579 13.5 7.5 13.5C7.91421 13.5 8.25 13.8358 8.25 14.25V16.5H12C12.8284 16.5 13.5 15.8284 13.5 15V12.75ZM9.75 15H12V11.25H14.25C14.6642 11.25 15 10.9142 15 10.5C15 10.0858 14.6642 9.75 14.25 9.75H12V6H8.25V3.75C8.25 3.33579 7.91421 3 7.5 3C7.08579 3 6.75 3.33579 6.75 3.75V6H3V8.25H3.75C4.99264 8.25 6 9.25736 6 10.5C6 11.7426 4.99264 12.75 3.75 12.75H3V15H5.25V14.25C5.25 13.0074 6.25736 12 7.5 12C8.74264 12 9.75 13.0074 9.75 14.25V15Z"
        fill="#696F88"
      />
    </svg>
  );
};

export default IntegrationsIcon;
